export const CONTROLS_ID = 'js-flowchart-controls';
